import React from "react";
import Form from "../Form/Form";
import HotelList from "../HotelList/HotelList";

export default function() {

  return (
    <main className="app-wrapper">
      <Form/>
      <HotelList />
    </main>
  );
}
